import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { ThemeProvider } from './theme/context'
import { LanguageProvider } from './i18n/context'
import { initSentry } from './sentry'

initSentry()

// When a fresh deploy ships new chunk hashes, any open tab still holds the old
// index.html and will request a chunk that no longer exists. Our static host
// falls back to index.html for unknown paths, so the browser receives HTML
// where it expected JS and throws:
//   "TypeError: 'text/html' is not a valid JavaScript MIME type"
// The recovery is to reload so the tab picks up the new index.html + hashes.
// We only reload once per session per chunk to avoid infinite loops if the
// asset is genuinely broken.
const reloadedForChunk = new Set<string>()
function shouldReload(reason: string): boolean {
  if (reloadedForChunk.has(reason)) return false
  reloadedForChunk.add(reason)
  return true
}
window.addEventListener('vite:preloadError', (event) => {
  if (shouldReload('vite:preloadError')) {
    event.preventDefault()
    window.location.reload()
  }
})
window.addEventListener('error', (event) => {
  const msg = event.message || ''
  if (
    msg.includes("'text/html' is not a valid JavaScript MIME type") ||
    msg.includes('Failed to fetch dynamically imported module')
  ) {
    if (shouldReload(msg)) window.location.reload()
  }
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </ThemeProvider>
  </StrictMode>,
)
